export var LocalStorageKey;
(function (LocalStorageKey) {
    /**
     * A boolean flag to determine if we need to enable session-timeout feature on localhost or not.
     * Default value is false.
     */
    LocalStorageKey["ENABLE_LOCAL_SESSION_TIMEOUT"] = "enable_local_session_timeout";
    /**
     * A number indicates the last active time of the user in any opened session.
     * It is being updated on each user activity (click, type), which are debounced for 1 second.
     */
    LocalStorageKey["LAST_ACTIVE_TIME"] = "last_active_time";
    LocalStorageKey["AUTH_TOKEN"] = "auth_token";
    LocalStorageKey["AUTH_CONFIG_DONE"] = "auth_config_done";
    LocalStorageKey["AUTH_TIME_DIFF"] = "auth_time_diff";
    //TAMS accounts and transaction account data key stored in the local storage, needed to remove them after logout
    LocalStorageKey["ACCOUNTS"] = "/accounts";
    LocalStorageKey["TRANSACTION_ACCOUNT"] = "accounts/TRA";
    LocalStorageKey["COUNTDOWN_TIMESTAMP"] = "lastSyncedAutoLogoutTimestampRefresh";
})(LocalStorageKey || (LocalStorageKey = {}));
export var CookieKey;
(function (CookieKey) {
    CookieKey["OBS_SESSION"] = "obs-session";
})(CookieKey || (CookieKey = {}));
//# sourceMappingURL=storage.js.map